import { MenuType } from "contexts/TabsMenuContext/types";
import { ComponentType, LazyExoticComponent } from "react";
import About from "../pages/about";
import Contact from "../pages/contact";
import Login from "../pages/login";
import Profile from "../pages/dashboard/profile";
import Setting from "../pages/dashboard/setting";
import Home from "../pages/home";
import Buildings from "../pages/dashboard/buildings";
import Meters from "../pages/dashboard/meters";
import Subscribers from "../pages/dashboard/subscribers";
import Cities from "../pages/dashboard/cities";
import Jurisdictions from "../pages/dashboard/jurisdictions";
import Provinces from "../pages/dashboard/provinces";
import Apartments from "../pages/dashboard/apartments";
import SubscriberDetails from "../pages/dashboard/subscribers/details";
import i18n from "../react-i18next";
import MeterDetails from "../pages/dashboard/meters/details";
import ApartmentDetails from "../pages/dashboard/apartments/details";
import Users from "../pages/dashboard/users";
import UserDetails from "../pages/dashboard/users/details";
import UsersRoles from "../pages/dashboard/users/roles";
import Install from "../pages/installations/install";
import InstallationsHistory from "../pages/installations/history";
import Overview from "../pages/dashboard/reports/overview";
import MetersReport from "../pages/dashboard/reports/meters";
import SubscribersReport from "../pages/dashboard/reports/subscribers";
import ApartmentsReport from "../pages/dashboard/reports/apartments";

export type TUserRole =
  | "superadmin"
  | "d_user"
  | "v_watersubscriber"
  | "d_watersubscriber"
  | "v_apartment"
  | "d_apartment"
  | "v_watermeter"
  | "d_watermeter"
  | "v_dashboard"
  | "watermertinstallation";

export type TPublicAppRoute = {
  path: string;
  element: ComponentType<any> | LazyExoticComponent<ComponentType<any>>;
  label: string;
  permissions?: TUserRole[];
};

export const PUBLIC_ROUTES: TPublicAppRoute[] = [
  {
    path: "/",
    element: Home,
    label: "Home",
  },
  {
    path: "/about",
    element: About,
    label: "About",
  },
  {
    path: "/contact",
    element: Contact,
    label: "Contact",
  },
  {
    path: "/login",
    element: Login,
    label: "Login",
  },
];

export const PRIVATE_ROUTES: MenuType[] = [
  {
    title: i18n.t("overviews"),
    name: "overview",
    isOpen: false,
    isActive: false,
    iconName: "MdReport",
    children: [
      {
        accessLabel: "OVERVIEW",
        permission: "OVERVIEW",
        title: i18n.t("overallReport"),
        name: "overview_meters",
        isActive: false,
        isUnique: true,
        path: "/dashboard/overview",
        element: Overview,
        label: "Overview",
        showInMenu: true,
        permissions: ["superadmin", "v_dashboard"],
      },
      {
        accessLabel: "REPORTS_METERS",
        permission: "REPORTS_METERS",
        title: i18n.t("metersReport"),
        name: "reports_meters",
        isActive: false,
        isUnique: true,
        path: "/dashboard/reports/meters",
        element: MetersReport,
        label: "Reports_meters",
        showInMenu: true,
        permissions: ["superadmin", "v_dashboard"],
      },
      {
        accessLabel: "REPORTS_SUBSCRIBERS",
        permission: "REPORTS_SUBSCRIBERS",
        title: i18n.t("subscribersReport"),
        name: "reports_subscribers",
        isActive: false,
        isUnique: true,
        path: "/dashboard/reports/subscribers",
        element: SubscribersReport,
        label: "Reports_subscribers",
        showInMenu: true,
        permissions: ["superadmin", "v_dashboard"],
      },
      {
        accessLabel: "REPORTS_APARTMENTS",
        permission: "REPORTS_APARTMENTS",
        title: i18n.t("apartmentsReport"),
        name: "reports_apartments",
        isActive: false,
        isUnique: true,
        path: "/dashboard/reports/apartments",
        element: ApartmentsReport,
        label: "Reports_apartments",
        showInMenu: true,
        permissions: ["superadmin", "v_dashboard"],
      },
    ],
  },
  {
    title: i18n.t("regions"),
    name: "region",
    isOpen: false,
    isActive: false,
    iconName: "MdMap",
    permissions: ["superadmin", "v_apartment", "d_apartment"],
    children: [
      {
        accessLabel: "PROVINCES",
        permission: "PROVINCES",
        title: i18n.t("provinces"),
        name: "provinces",
        isActive: false,
        isUnique: true,
        path: "/dashboard/provinces",
        element: Provinces,
        label: "Regions",
        showInMenu: true,
        permissions: ["superadmin"],
      },
      {
        accessLabel: "CITIES",
        permission: "CITIES",
        title: i18n.t("cities"),
        name: "cities",
        isActive: false,
        isUnique: true,
        path: "/dashboard/cities",
        element: Cities,
        label: "Cities",
        showInMenu: true,
        permissions: ["superadmin"],
      },
      {
        accessLabel: "JURISDICTIONS",
        permission: "JURISDICTIONS",
        title: i18n.t("jurisdictions"),
        name: "jurisdictions",
        isActive: false,
        isUnique: true,
        path: "/dashboard/jurisdictions",
        element: Jurisdictions,
        label: "Jurisdictions",
        showInMenu: true,
        permissions: ["superadmin"],
      },
      {
        accessLabel: "APARTMENTS",
        permission: "APARTMENTS",
        title: i18n.t("apartments"),
        name: "apartments",
        isActive: false,
        isUnique: false,
        path: "/dashboard/apartments",
        element: Apartments,
        label: "Apartments",
        showInMenu: true,
        permissions: ["superadmin", "v_apartment", "d_apartment"],
      },
      {
        accessLabel: "APARTMENTS_DETAILS",
        permission: "APARTMENTS_DETAILS",
        title: i18n.t("apartmentDetails"),
        name: "apartments_details",
        isActive: false,
        isUnique: true,
        path: "/dashboard/apartments/details/:apartmentId",
        element: ApartmentDetails,
        label: "Apartments_details",
        permissions: ["superadmin", "v_apartment", "d_apartment"],
      },
    ],
  },
  {
    title: i18n.t("meters"),
    name: "meters",
    isOpen: false,
    isActive: false,
    iconName: "MdGasMeter",
    permissions: ["superadmin", "v_watermeter", "d_watermeter"],
    children: [
      {
        accessLabel: "METERS",
        permission: "METERS",
        title: i18n.t("meters"),
        name: "meters",
        isActive: false,
        isUnique: true,
        path: "/dashboard/meters",
        element: Meters,
        label: "Regions",
        showInMenu: true,
        permissions: ["superadmin", "v_watermeter", "d_watermeter"],
      },
      {
        accessLabel: "METERS_DETAILS",
        permission: "METERS_DETAILS",
        title: i18n.t("meterDetails"),
        name: "meters_details",
        isActive: false,
        isUnique: true,
        path: "/dashboard/meters/details/:meterId",
        element: MeterDetails,
        label: "Meters_details",
        permissions: ["superadmin", "v_watermeter", "d_watermeter"],
      },
    ],
  },
  {
    title: i18n.t("subscribers"),
    name: "subscribers",
    isOpen: false,
    isActive: false,
    iconName: "MdPerson",
    permissions: ["superadmin", "v_watersubscriber", "d_watersubscriber"],
    children: [
      {
        accessLabel: "SUBSCRIBERS",
        permission: "SUBSCRIBERS",
        title: i18n.t("subscribers"),
        name: "subscribers",
        isActive: false,
        isUnique: true,
        path: "/dashboard/subscribers",
        element: Subscribers,
        label: "Subscribers",
        showInMenu: true,
        permissions: ["superadmin", "v_watersubscriber", "d_watersubscriber"],
      },
      {
        accessLabel: "SUBSCRIBERS_DETAILS",
        permission: "SUBSCRIBERS_DETAILS",
        title: i18n.t("subscriberDetails"),
        name: "subscribers_details",
        isActive: false,
        isUnique: true,
        path: "/dashboard/subscribers/details/:subscriberId",
        element: SubscriberDetails,
        label: "Subscribers_details",
        permissions: ["superadmin", "v_watersubscriber", "d_watersubscriber"],
      },
    ],
  },
  {
    title: i18n.t("users"),
    name: "users",
    isOpen: false,
    isActive: false,
    iconName: "MdPerson",
    permissions: ["superadmin", "d_user"],
    children: [
      {
        accessLabel: "USERS",
        permission: "USERS",
        title: i18n.t("users"),
        name: "users",
        isActive: false,
        isUnique: true,
        path: "/dashboard/users",
        element: Users,
        label: "Users",
        showInMenu: true,
        permissions: ["superadmin", "d_user"],
      },
      // {
      //   accessLabel: "USERS_ROLES",
      //   permission: "USERS_ROLES",
      //   title: i18n.t("roles"),
      //   name: "users_roles",
      //   isActive: false,
      //   isUnique: true,
      //   path: "/dashboard/roles",
      //   element: UsersRoles,
      //   label: "Users_roles",
      //   showInMenu: true,
      //   permissions: ["superadmin", "d_user"],
      // },
      {
        accessLabel: "USERS_DETAILS",
        permission: "USERS_DETAILS",
        title: i18n.t("userDetails"),
        name: "users_details",
        isActive: false,
        isUnique: true,
        path: "/dashboard/users/details/:userId",
        element: UserDetails,
        label: "Users_details",
        permissions: ["superadmin", "d_user"],
      },
    ],
  },
  {
    title: i18n.t("installations"),
    name: "installations",
    isOpen: false,
    isActive: false,
    iconName: "MdInstallDesktop",
    permissions: ["superadmin", "watermertinstallation"],
    children: [
      {
        accessLabel: "INSTALLATIONS",
        permission: "INSTALLATIONS",
        title: i18n.t("installation"),
        name: "install",
        isActive: false,
        isUnique: true,
        path: "/dashboard/installations/install",
        element: Install,
        label: "Installations_install",
        showInMenu: true,
        permissions: ["superadmin", "watermertinstallation"],
      },
      {
        accessLabel: "INSTALLATIONS_HISTORY",
        permission: "INSTALLATIONS_HISTORY",
        title: i18n.t("installationsHistory"),
        name: "installations_history",
        isActive: false,
        isUnique: true,
        path: "/dashboard/installations/history",
        element: InstallationsHistory,
        label: "Installations_history",
        showInMenu: true,
        permissions: ["superadmin", "watermertinstallation"],
      },
    ],
  },
];
